export default __webpack_public_path__ + "static/media/ChevronDownGrey.042a1aba.svg";